import React, { useEffect, useState } from 'react';

const PlayerUiNameWidget = ({ creature, socket }) => {
    const [name, setName] = useState(creature.name || '');

    useEffect(() => {
        setName(creature.name || '');
    }, [creature.name, creature.creatureGuid]);

    const handleName = (event) => {
        setName(event.target.value);
    };

    const submitName = () => {
        socket.emit('creatureNameChange', name, creature.creatureGuid, 'player');
    };

    return (
        <div className='nameContainerPlayerUi editHpGrowPlayerUi'>
            <div className="nameMenuPlayerUi">
                <div className='hpInputRowContainer'>
                    <div className='nameInputsController'>
                        <label className='widgetLabel acPlayerUi' htmlFor='creature-name'>Name</label>
                        <input id='creature-name' className='editStatsInputExtraPlayerUi' type='text' value={name} onChange={handleName} onFocus={(event) => event.target.select()} onBlur={submitName} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerUiNameWidget;